<template>
<b-row class="m-2">
    <b-col v-if="loaded === false">
         <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else>
        <b-row>
            <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>
            <b-col>
                <h1>{{ecmResourceStrings.ttlTestEcmConnection}} (ECM Repository ID : {{id}}; Type : {{type}})</h1>
            </b-col>
            <b-col class="text-right OTbtnContainer" cols="4">
                <otif-button class="OTSecondary"  @click.native="back" id="otBack" >{{ecmResourceStrings.lblBack}}</otif-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <otif-ecm-table-info
                :rows="repositories"
                :columns="columns"
                :paginated="false"
                :customOptions="customOptions"
                :sortCallback="sort_data"
                :totalRowsCallback="totalRows">
                <template slot="table-header">
                    <h1 class="text-center OT-table-title"></h1>
                </template>
            </otif-ecm-table-info>
            </b-col>
        </b-row>
    </b-col>
</b-row>
</template>

<script>

import ecmRepositories from '@/ecm/collections/ecmrepositories.js';
import axios from 'axios';
import { showMessage} from '../../../utils/commonECM.js';
import { sortOn } from '../../../utils/commonECM.js';
import ErrorColumn from '../../links/testconnectionerror.vue';
import StatusColumn from '../../links/testconnectionstatus.vue';
import ExceptionColumn from '../../links/testconnectionexception.vue';
import ECMErrorDialog from '../../modals/ECMCrawlerMessageDlg.vue';

export default {

    props: {
        id:{
            required: true
        },
        type:{
            required: true
        },
    },

    data() {
        return {
            ecmResourceStrings: require('../../../utils/resourceECM.js'),   
            sortDir:'asc',
            messageDlg:false,
            configs: [],
            ecmRepositories: new ecmRepositories({paginated: false }),
            loaded: false,
            customOptions:  [],
            columns: [
            {
                name: 'description',
                label: 'ECM Connection Description',
                sortable: true,
                editable:false,
                render(row) {
                    return row.description;
                }
            },{
                name: 'status',
                label: 'Status',
                sortable: true,
                editable:false,
                width:'10%',
                displayComponent:StatusColumn,
            },{
                name: 'error',
                label: 'Error Description or Comments',
                sortable: false,
                editable:false,
                displayComponent:ErrorColumn,
            },{
                name: 'exceptions',
                label: 'Exceptions',
                sortable: false,
                editable:false,
                width:'20%',
                displayComponent:ExceptionColumn,
            }],
        }
    },

    computed: {
        repositories() {
            return this.configs;
        }
    },

    methods: {
        refresh() {
            this.loaded = true;
        },

        sort_data(colNumber, dir) {
            const fieldName = this.columns[colNumber].name;
            this.ecmRepositories.sort(fieldName, dir);
        },

        totalRows() {
            return this.ecmRepositories.total_count;
        },
                 
        back() {
            this.$router.push('/settings/ecmrepositories');
        },

        showException(row){
            var that = this;
            var partsArray = row.resultid.split('-');
            const crawlerprocesid = partsArray[1].trim();
            axios.get('/mtm-gateway-api/v1/services/ecm/query/executionDetails/' + crawlerprocesid, 
            {headers: {"Content-Type": "application/json; charset=UTF-8"}})
                .then((res) => {
                    if (res.data) {   
                        var otputtext='';
                        const oticExecutionDetails = res.data.oticExecutionDetails;
                        if(oticExecutionDetails)
                        {
                            const len = oticExecutionDetails.length;
                         
                            if(len!=0)
                            {
                                for(var i=0; i<len; i++)
                                {
                                    const execdetails = oticExecutionDetails[i];
                                  
                                    if(execdetails)
                                    {
                                        const exceptionsfull = execdetails.exceptions;
                                          
                                        otputtext += exceptionsfull;
                                    }
                                }
                            }
                        }
                        if(otputtext == '' || otputtext == null || otputtext == undefined)
                        {
                            otputtext = row.errordescription;
                        }
                        showMessage(this, 'info', that.ecmResourceStrings.ttlExceptions,'', true, otputtext);
                    }
                })
                .catch((err) => {
                    this.$snotify.clear();
                    if(err.message)
                    {
                        this.$snotify.error(err.message);
                    }
                    else  if(err.response)
                    {
                        if(err.response.statusText)
                            this.$snotify.error(err.response.statusText);
                        else if(err.response.data && err.response.data.statusText )
                            this.$snotify.error(err.response.data.statusText);
                    }
                });
        },

        StartTestRepositoryConnectionConfig : function(configConnectionID)
        {
            var that = this;
            const connString=that.createBodyPostString(configConnectionID);
            axios.post('/mtm-gateway-api/v1/services/ecm/actions/CrawlerRepositoryTestConnection', connString, 
                {headers: {"Content-Type": "application/json; charset=UTF-8"}})
                .then((res) => {
                    if (res.data) {   
                            const crawlerOperationDetails = res.data.crawlerOperationDetails;
                            if(crawlerOperationDetails)
                            {
                                const jobid = crawlerOperationDetails[0].jobId;
                                
                                that.TestConnection(configConnectionID, jobid);
                            }   
                    }
                })
                .catch((err) => {
                    this.$snotify.clear();
                    if(err.message)// Network error, handle it
                    {
                        var result = that.configs.filter((el) => (el.index == configConnectionID));
                        if (result != undefined && result.length == 1)
                        {
                            if(result[0])
                            {
                                result[0].status = 'Error';
                                result[0].errordata = "Error";
                                result[0].errorshorttext = this.getShortDescription(err.message);
                                result[0].errordescription =err.message;
                            }
                        }
                        else
                        {      
                            this.$snotify.error(err.message);
                        }
                    }
                    else  if(err.response)// Server responded, handle it
                    {
                        this.$snotify.error("Error");
                    }
                    
                    this.loaded = true;
                }
            );
        },

        createBodyPostString : function(id)
        {
            var that = this;
                
            const configstring = '{"repositoryId": "' +  that.id + '", "operationType": "Idle", "operationMode": "Start", "operationStatus": "Idle", "engineName":"1", "partitionId":"-1", "ecmConnectionId": "' +  id + '","actionStatusCode":"0", "actionStatusMessage":"" , "executionStatusCode":"0", "executionFolderPathOrId":"", "executionComments":"", "jobId":"" }';
                               
            const connString = '{"crawlerOperationDetails":[' + configstring + ']}';
                
            return connString;
        },

        getShortDescription :function(fullmessage)
        {
            var message = "";
            if(fullmessage)
            {
                message = fullmessage;
            }
            var msgshort = '';
            const len = message.length;
            if(len < 50)
            {
                msgshort = message;
            }
            else
            {
                const res = message.substring(0, 47) + "...";
                msgshort = res;
            }
            return msgshort;
        },

        TestConnection : function(id, jobid)
        {
            var that = this;
            axios.get('/mtm-gateway-api/v1/services/ecm/actions/CrawlerRepositoryTestConnection/' + that.id)
                .then((res) => {
                if (res.data) {
                    if(res.data.crawlerOperationDetails)
                    {
                        const crawlerOperationDetails = res.data.crawlerOperationDetails;
                        const len = crawlerOperationDetails.length;

                        for(var i = 0; i < len; i++)
                        {
                            const oid = crawlerOperationDetails[i].jobId;
                            
                            if(oid == jobid || id == crawlerOperationDetails[i].ecmConnectionId)
                            {
                                const operationStatus = res.data.crawlerOperationDetails[i].operationStatus;
                                var error = '';
                                if(crawlerOperationDetails[i].executionComments)
                                {
                                    error = crawlerOperationDetails[i].executionComments;
                                }
                                if(operationStatus == "Running" && error == '')                    
                                {
                                    that. TestConnection(id,jobid);
                                }
                                else
                                {
                                    const actioncode = crawlerOperationDetails[i].actionStatusCode;
                                    const executionStatusCode = crawlerOperationDetails[i].executionStatusCode;
                                    var resultnew = that.configs.filter((el) => (el.index == id));
                                    if (resultnew != undefined && resultnew.length == 1)
                                    {
                                        if(resultnew[0].status)
                                            resultnew[0].status = operationStatus;
                                        resultnew[0].resultid = jobid; 
                                                                                        
                                        if(error== "" || error == "**")//everithing is ok
                                        {
                                            resultnew[0].errordata = error;
                                            resultnew[0].errordescription =error;
                                        }
                                        else
                                        {
                                            resultnew[0].errordata = "Error";
                                            if(error)
                                            {
                                                resultnew[0].errorshorttext = this.getShortDescription(error);
                                                resultnew[0].errordescription =error;
                                            }
                                            else
                                            {
                                                resultnew[0].errorshorttext = "Error";
                                                resultnew[0].errordescription ="Unknown error";
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            })
            .catch((err) => {
                if(err.message)
                {
                    var result = that.configs.filter((el) => (el.index == id));
                    if (result != undefined && result.length == 1)
                    {
                        if(result[0])
                        {
                            result[0].status = 'Error';
                            result[0].errordata = "Error";
                            result[0].errorshorttext = this.getShortDescription(err.message);
                            result[0].errordescription =err.message;
                        }
                    }
                    else
                    {      
                        this.$snotify.error(err.message);
                    }
                }
                else  if(err.response)
                {
                    if(err.response.statusText)
                        this.$snotify.error(err.response.statusText);
                    else if(err.response.data && err.response.data.statusText )
                        this.$snotify.error(err.response.data.statusText);
                }
            });
        },
    },

    components: {
        ECMErrorDialog
    },

    mounted() {
        var breadcrumbs = [{
            name: 'settings',
            meta: { label: 'Settings' }
        },{
            name: 'ecm-repositories',
            meta: { label: 'Repositories' }
        },{
            name: 'ecm-test-repo-connection',
            meta: { label: 'Test ECM Connection ' }
        }];
        this.$store.commit('breadcrumbs', breadcrumbs);
    },

    created() {
        var that = this;
        that.configs = [];
        axios.get('/mtm-gateway-api/v1/services/ecm/ECMRepositories/'+ that.id)
        .then((res) => {
            this.$snotify.clear();
            if (res.data) {
                //partitions and connections come from repositories
                //ECMRepositoriesStatusListView line 90
                const parameters = res.data.configData;
                if(parameters)
                {
                    const len = parameters.length;
                    if(len!=0)
                    {
                        for(var i=0; i<len; i++)
                        {
                            const oneelement = parameters[i];
                            if(oneelement)
                            {
                                const paramfullName = oneelement.name;
                                var paramIndex = 0;//for configs
                                var paramname = '';
                                //parse name to see what we have
                                //could be one word
                                //repoParam.0.hostName, repoPartitionTask.0.folderPathOrId, repoExcludedFolder.1.folderPathOrId
                                const namesArray = paramfullName.split(".");
                                const lennames = namesArray.length;
                                if(lennames > 1)
                                {
                                    if (namesArray[0] == "repoParam")
                                    {
                                        paramIndex = namesArray[1]; 
                                        paramname = namesArray[2]; 
                                        var result = that.configs.filter((el) => (el.index == paramIndex));
                                        if (result != undefined && result.length == 0)
                                        {
                                            // not found - add
                                            that.configs.push({"index" : paramIndex, "description" : '', "status": 'Started', "errordata" : '', "errorshorttext" : '', "errordescription" :'', "resultid": ''});
                                            that.StartTestRepositoryConnectionConfig(paramIndex);
                                            //get it
                                            var resultnew = that.configs.filter((el) => (el.index == paramIndex));
                                            if (resultnew != undefined && resultnew.length == 1)
                                            {
                                                if(paramname == 'description')
                                                {
                                                    resultnew[0].description = oneelement.value;
                                                }
                                            }
                                        }
                                        else if (result != undefined && result.length == 1)
                                        {
                                            if(paramname == 'description')
                                            {
                                                result[0].description = oneelement.value;
                                            }
                                        } 
                                    }
                                }
                            }
                        }
                    }
                }
                this.loaded = true;
            }
        })
        .catch((err) => {
            this.$snotify.clear();
            if(err.message)
            {
                this.$snotify.error(err.message);
            }
            else  if(err.response)
            {this.$snotify.error(err.response.data);
            }
            this.loaded = true;
            
        });
    }
}

</script>
